import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { AccountQualificationDetail } from './AccountQualificationDetail';

export class AccountQualificationDetailsResource extends FBaseService {
  public async getCyclesForAccount(fiId: string, akk: string): Promise<number[]> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/reporting/${fiId}/account-qualification-details/cycles/${akk}`,

    );
    const results: number[] = response.data.data;
    return results;
  }

  public async getAccountQualificationDetail(fiId: string, cycleId: number, productId: string, akk: string)
    : Promise<AccountQualificationDetail> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/reporting/${fiId}/account-qualification-details/by-key/${cycleId}/${productId}/${akk}`,
    );
    const results: AccountQualificationDetail = response.data.data;
    return results;
  }
}

export default AccountQualificationDetailsResource;
